var exports = {
  "kL": "x31de4314--01c0fe--container",
  "iE": "x31de4314--01c0fe--wrapper",
  "DD": "x31de4314--01c0fe--title",
  "h_": "x31de4314--01c0fe--description",
  "x6": "x31de4314--01c0fe--button",
};

module.exports = exports;
